import * as createWebhooks from 'store/actions/webhooks/createWebhooks';
import * as deleteWebhooks from 'store/actions/webhooks/deleteWebhooks';
import * as fetchWebhooks from 'store/actions/webhooks/fetchWebhooks';
import * as updateWebhooks from 'store/actions/webhooks/updateWebhooks';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';

// Fetch multiple Webhooks.
function* fetchWebhooksAsync({ payload }) {
    try {
        // Build the URL.
        const url = `${ config.getApiBaseUrl() }/webhooks`;

        // Fetch the data.
        const response = yield apiClient.read(url, payload);

        // Send the data the success action.
        yield put(fetchWebhooks.fetchWebhooksSuccess(response));
    } catch (error) {
        // Trigger the error action.
        yield put(fetchWebhooks.fetchWebhooksFailure(error));
    }
}

// Fetch singular Webhook.
function* fetchWebhookAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
    } = payload;

    try {
        // Build the URL.
        const url = `${ config.getApiBaseUrl() }/webhooks/${ id }`;

        // Fetch the data.
        const response = yield apiClient.read(url);

        // Send the data to the success action.
        yield put(fetchWebhooks.fetchWebhookSuccess(response));

        yield onSuccess();
    } catch (error) {
        // Trigger the error action.
        yield put(fetchWebhooks.fetchWebhookFailure(error, payload));

        yield onError(error);
    }
}

// Create Webhook.
function* createWebhookAsync({ payload }) {
    const {
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        // Build the URL.
        const url = `${ config.getApiBaseUrl() }/webhooks`;
        // Post the data.
        const response = yield apiClient.create(url, values);

        yield put(createWebhooks.createWebhookSuccess(response));

        yield onSuccess();
    } catch (error) {
        // Trigger the error action.
        yield put(createWebhooks.createWebhookFailure(error));

        yield onError(error);
    }
}

function* createWebhookSuccessAsync() {
    yield put(showNotification('notifications.webhooks.create.success'));
}

// Update Webhook.
function* updateWebhookAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        // Build the URL.
        const url = `${ config.getApiBaseUrl() }/webhooks/${ id }`;

        // Post the data.
        const response = yield apiClient.patch(url, values);

        yield put(updateWebhooks.updateWebhookSuccess(response));

        yield onSuccess();
    } catch (error) {
        // Trigger the error action.
        yield put(updateWebhooks.updateWebhookFailure(error));

        yield onError(error);
    }
}

function* updateWebhookSuccessAsync() {
    yield put(showNotification('notifications.webhooks.update.success'));
}

// Delete Webhook.
function* deleteWebhookAsync({ payload }) {
    try {
        // Build the URL.
        const url = `${ config.getApiBaseUrl() }/webhooks/${ payload.id }`;

        // Delete the data.
        yield apiClient.delete(url);

        if (payload.callback) {
            yield payload.callback();
        }

        yield put(deleteWebhooks.deleteWebhookSuccess(payload));
    } catch (error) {
        // Trigger the error action.
        yield put(deleteWebhooks.deleteWebhookFailure(error));
    }
}

function* deleteWebhookSuccessAsync() {
    // Redirect the user to the correct page.
    yield put(showNotification('notifications.webhooks.delete.success'));
}

function* failureMessage({ error }) {
    const { message } = error.response;

    if (!message) {
        return;
    }

    yield put(showNotification(message, 'warning'));
}

export default function* WebhooksSagas() {
    yield [
        takeEvery('FETCH_WEBHOOKS', fetchWebhooksAsync),
        takeEvery('FETCH_WEBHOOKS_FAILURE', failureMessage),

        takeEvery('FETCH_WEBHOOK', fetchWebhookAsync),
        takeEvery('FETCH_WEBHOOK_FAILURE', failureMessage),

        takeEvery('CREATE_WEBHOOK', createWebhookAsync),
        takeEvery('CREATE_WEBHOOK_FAILURE', failureMessage),
        takeEvery('CREATE_WEBHOOK_SUCCESS', createWebhookSuccessAsync),

        takeEvery('UPDATE_WEBHOOK', updateWebhookAsync),
        takeEvery('UPDATE_WEBHOOK_FAILURE', failureMessage),
        takeEvery('UPDATE_WEBHOOK_SUCCESS', updateWebhookSuccessAsync),

        takeEvery('DELETE_WEBHOOK', deleteWebhookAsync),
        takeEvery('DELETE_WEBHOOK_FAILURE', failureMessage),
        takeEvery('DELETE_WEBHOOK_SUCCESS', deleteWebhookSuccessAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/webhooksSagas.js